/* Packages */
import React, { useEffect, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import { useController, useFormContext } from 'react-hook-form';

/* Hooks */
import useFlowContext from 'conversie-flow-bundle/assets/js/components/flow/hooks/useFlowContext';
import { useFallbackFormContext } from 'conversie-flow-bundle/assets/js/components/flow/context/FallbackFormContext';

export default function ConversionFieldSelect(props) {
    const isInitialRenderRef = useRef(true);
    const {
        translate = () => {},
    } = useFlowContext();

    const { colClassName, field, path, id, updateValue } = props;
    const { type, label, choices, required, disabled, placeholder = null, value, name, errors } = field;

    const form = useFormContext();
    const fallbackForm = useFallbackFormContext();
    const {
        control,
    } = form || fallbackForm;

    const { field: { onChange, onBlur, ref }, fieldState } = useController({
        control,
        name: path,
        defaultValue: value,
        rules: {
            required: {
                value: required,
                message: translate(`conversion_flow_bundle.flow.field.error.required`),
            },
        },
    });

    const error = fieldState.error?.message || errors?.[0];

    useEffect(() => {
        if (isInitialRenderRef.current) {
            isInitialRenderRef.current = false;
            return;
        }
        onChange(value);
    }, [value]);

    const requiredText = translate(`webstores_conversion_flow.common.required_field`);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                {required === true && requiredText.length !== 0 &&
                    <span className="required-label">{requiredText}</span>
                }
                <Form.Select
                    ref={ref}
                    className={`${error ? 'is-error' : ''}`}
                    name={id}
                    {...{
                        required,
                        disabled,
                    }}
                    value={value[0] || ''}
                    onChange={(e) => {
                        updateValue([choices?.find((choice) => `${choice.key}` === `${e.target.value}`)?.key]);
                    }}
                    onBlur={onBlur}
                >
                    {placeholder && (
                        <option value="">{placeholder}</option>
                    )}
                    {choices?.map((choice, choiceIndex) => {
                        return (
                            <option key={choice.key} value={choice.key}>{choice.label}</option>
                        )
                    })}
                </Form.Select>
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
